import React from "react";
import { Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";

export interface SelectOption {
  label: string;
  value: string;
}

export interface FormikButtonListProps {
  options: SelectOption[];
  name: string;
  value: string[];
}

//
// tslint:disable:max-line-length
export const FormikButtonList: React.FunctionComponent<FormikButtonListProps> = (props: FormikButtonListProps) => {
  return (
    <div className="formik-bl d-flex align-items-start flex-wrap">
      <Field name={props.name}>
        {({ field, form }: { field: any; form: any }): React.ReactNode => {
          return props.options.map((o, i) => {
            return (
              <div
                className={`mt-2 me-1 cursor-pointer item ${field.value.includes(o.value) === true ? "include" : ""}`}
                key={i}
                onClick={(): void => {
                  if (field.value.includes(o.value)) {
                    const nextValue = field.value.filter((value: string) => value !== o.value);
                    form.setFieldValue(props.name, nextValue);
                  } else {
                    const nextValue = field.value.concat(o.value);
                    form.setFieldValue(props.name, nextValue);
                  }
                }}
              >
                {o.label}&nbsp;
                {field.value.includes(o.value) === true && <FontAwesomeIcon icon={faCheck} />}
                {field.value.includes(o.value) === false && <FontAwesomeIcon icon={faPlus} />}
              </div>
            );
          });
        }}
      </Field>
    </div>
  );
};
